import modelanalysis from "./modelanalysis.js";
import addmodel from "./addmodel.js";
import modeldetail from "./modeldetail.js";

export default {
  modelanalysis,
  addmodel,
  modeldetail,
};
